import { createModel } from 'xstate/lib/model';

import { ComponentModel, ComponentEvents } from './types';

const componentModel = createModel<ComponentModel, ComponentEvents>({
  id: null,
  type: null,
  name: '',
  description: '',
  allocatedQuantity: null,
  enabled: null,
  recurring: null,
  currency: null,
  allowFractionalQuantities: null,
  updatesAllowed: null,
  pricePoint: {
    id: null,
    rolloverPrepaidRemainder: null,
    renewPrepaidAllocation: null,
    expirationInterval: null,
    expirationIntervalUnit: null,
    type: null,
    prices: [],
  },
  unit: {
    name: '',
    balance: 0,
    overageBalance: 0,
  },
});

export default componentModel;
